.anchor {
  display: inline-flex;
}

/* The mockup's `.tip`. */
.tooltip {
  position: fixed;
  z-index: var(--z-toast);
  inset-inline-start: var(--floating-left, 8px);
  inset-block-start: var(--floating-top, 8px);
  max-inline-size: 280px;
  padding: 6px 10px;
  border: 1px solid var(--border);
  border-radius: var(--radius-control);
  background: var(--surface-raised);
  color: var(--text);
  font-size: var(--font-size-12);
  box-shadow: var(--shadow-popover);

}
